import { render, staticRenderFns } from "./supportModalChat.vue?vue&type=template&id=c78bb00c"
import script from "./supportModalChat.vue?vue&type=script&lang=js"
export * from "./supportModalChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports